/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 顧客フォームの定数クラス
 *
 * @author duan
 * @copyright Copyright 2021 TechMatrix Corporation, Inc. All rights reserved.
 */

export default class {
  /**
   * 入力タイプ : INPUT
   */
  static get INPUT_TYPE_INPUT() {
    return '0'
  }
  /**
   * 入力タイプ : INPUT（二つ）
   */
  static get INPUT_TYPE_DOUBLE_INPUT() {
    return '1'
  }
  /**
   * 入力タイプ : 日付
   */
  static get INPUT_TYPE_DATE() {
    return '2'
  }
  /**
   * 入力タイプ : ラジオボタン
   */
  static get INPUT_TYPE_RADIO() {
    return '3'
  }
  /**
   * 入力タイプ : テキスト（複数行）
   */
  static get INPUT_TYPE_TEXTAREA() {
    return '4'
  }
  /**
   * 入力タイプ : 選択リスト
   */
  static get INPUT_TYPE_SELECT() {
    return '5'
  }
  /**
   * 入力タイプ : 日時
   */
  static get INPUT_TYPE_DATETIME() {
    return '6'
  }
  /**
   * 入力タイプ : チェックボックス
   */
  static get INPUT_TYPE_CHECKBOX() {
    return '7'
  }
}



// WEBPACK FOOTER //
// ./src/constants/CustomerInputFormConst.js